import { useCurrencyParser } from "@/hooks";

export default function Price({minmaxHarga}) {
    return (
        <h2 className="text-mm-accent font-bold">
            {minmaxHarga.min_harga ==
                minmaxHarga.max_harga
                ? minmaxHarga.min_harga == 0
                    ? "Gratis"
                    : useCurrencyParser(
                        minmaxHarga.min_harga
                    )
                : useCurrencyParser(
                    minmaxHarga.min_harga
                ) +
                " - " +
                useCurrencyParser(
                    minmaxHarga.max_harga
                )}
        </h2>
    )
}